import { HIDDEN_CLASS, WITH_STICKY_BUYBOX } from './consts'

import 'intersection-observer'

export default () => {
  const stickyBuyBox = document.querySelector(
    '[data-clientside-hook~="stickyBuyBox"]'
  )
  const variantsContainer = document.querySelector('#h_ProductVariants')

  if (stickyBuyBox && variantsContainer) {
    const IO = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          stickyBuyBox.classList.add(HIDDEN_CLASS)
          document.body.classList.remove(WITH_STICKY_BUYBOX)
          return
        }

        if (entry.boundingClientRect.top > 0) {
          stickyBuyBox.classList.add(HIDDEN_CLASS)
          document.body.classList.remove(WITH_STICKY_BUYBOX)
        } else {
          stickyBuyBox.classList.remove(HIDDEN_CLASS)
          // add an identifier to body to change position of chat box in IT over GTM
          document.body.classList.add(WITH_STICKY_BUYBOX)
        }
      },
      {
        root: null,
        threshold: 0,
      }
    )

    IO.observe(variantsContainer)
  }

  const quantitySelect = document.querySelector('#product_quantity_BuyBox')
  const rxModalBuyBtn = document.querySelector(
    `[data-clientside-hook~="conventional-prescription"]`
  )

  if (quantitySelect && rxModalBuyBtn) {
    const rxModalBtnUrl = new URL(rxModalBuyBtn.href)

    quantitySelect.addEventListener('change', event => {
      const quantity = parseInt(event.target.value, 10)

      if (!isNaN(quantity)) {
        rxModalBtnUrl.searchParams.set('quantity', quantity)
        rxModalBuyBtn.href = rxModalBtnUrl.toString()
      }
    })
  }
}
